import React, { useEffect, useState } from "react";
import { Button, notification, Spin } from "antd";
import Icon from "@mdi/react";
import { mdiChevronDown } from "@mdi/js";
import DestinationCard from "./components/DestinationCard";
import LocationsApi from "../../../api-services/locations-api.service";
import type { Location } from "../../../interfaces/country.interface";

const PAGE_SIZE = 10;

const locationsApi = new LocationsApi();

export default function DestinationsListing() {
  const [destinations, setDestinations] = useState<Location[]>([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [loading, setLoading] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);

  useEffect(() => {
    const isFirstPage = page === 1;
    if (isFirstPage) setLoading(true);
    else setLoadingMore(true);

    locationsApi.getLocations({
      group: ["GD_Standard", "GD_In_Depth"],
      highlighted: true,
      page,
      limit: PAGE_SIZE,
    })
      .then(({ locations, totalPages }) => {
        setDestinations((prev) => (isFirstPage ? (locations as Location[]) : [...prev, ...(locations as Location[])]));
        setTotalPages(totalPages);
      })
      .catch(() => notification.error({ message: "Something went wrong while loading Destinations." }))
      .finally(() => {
        setLoading(false);
        setLoadingMore(false);
      });
  }, [page]);

  return (
    <div id="destinations-listing-v2">
      <div className="destinations-listing-v2__content">
        <div className="destinations-listing-v2__header">
          <h1>Explore More Destinations</h1>
          <p>What other travellers are booking.</p>
        </div>
        <Spin size="large" className="loader" spinning={loading} />
        {!loading && (
          <div className="destinations-listing-v2__grid">
            {destinations.map((destination) => (
              <DestinationCard key={destination.id} destination={destination} />
            ))}
          </div>
        )}
        {!loading && page < totalPages && (
          <div className="destinations-listing-v2__see-more">
            <Button type="primary" loading={loadingMore} onClick={() => setPage((prev) => prev + 1)}>
              See More <Icon path={mdiChevronDown} size="18px" />
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}
